import {
  FETCH_ULB_USERS_REQUEST,
  FETCH_ULB_USERS_SUCCESS,
  FETCH_ULB_USERS_FAILURE,
  CREATE_ULB_USER_REQUEST,
  CREATE_ULB_USER_SUCCESS,
  CREATE_ULB_USER_FAILURE,
  UPDATE_ULB_USER_REQUEST,
  UPDATE_ULB_USER_SUCCESS,
  UPDATE_ULB_USER_FAILURE,
  RESET_ULB_USER_PASSWORD_REQUEST,
  RESET_ULB_USER_PASSWORD_SUCCESS,
  RESET_ULB_USER_PASSWORD_FAILURE,
} from "../../actions/user-management/ulbUserActions";

const initialState = {
  loading: false,
  users: [],
  pagination: {
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
  },
  error: null,
};

const ulbUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ULB_USERS_REQUEST:
    case CREATE_ULB_USER_REQUEST:
    case UPDATE_ULB_USER_REQUEST:
    case RESET_ULB_USER_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ULB_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case CREATE_ULB_USER_SUCCESS:
    case UPDATE_ULB_USER_SUCCESS:
    case RESET_ULB_USER_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: null };

    case FETCH_ULB_USERS_FAILURE:
    case CREATE_ULB_USER_FAILURE:
    case UPDATE_ULB_USER_FAILURE:
    case RESET_ULB_USER_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default ulbUserReducer;
